module.exports = __webpack_public_path__ + "static/media/congress.862d5d98.jpg";